import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO } from "data/navigation";
import DropdownTravelers from "../../components/Header/DropdownTravelers";
import { UserTypeEnum } from "../../@core/enums/UserType.enum";
import { useUserSessionStore } from "../../stores/UserSession.store";
import ncNanoId from '../../utils/ncNanoId';

function Navigation() {
  const user = useUserSessionStore((state) => state.user);
  return (
    <ul className="nc-Navigation hidden md:flex lg:items-center lg:space-x-1 relative gap-3">
      <NavigationItem menuItem={{
        id: ncNanoId(),
        href: "/services",
        name: "Services",
      }}/>
      {NAVIGATION_DEMO.map((item) => (
        <NavigationItem key={item.id} menuItem={item}/>
      ))}
      {user?.role === UserTypeEnum.COMPANY && <DropdownTravelers/>}
    </ul>
  );
}

export default Navigation;
